export const displayTitleMarkupText = (markup: any) => {
  return markup;
};
